module.exports = __webpack_public_path__ + "static/media/Close-Square.257c486b.svg";